<template>
    <span>
        <a @click="show = true" class="info-link">{{ 'More info' | translation }}</a>
        <info-modal :show="show" @input="show = false" />
    </span>
</template>

<script>
import InfoModal from '@/components/product/InfoModal';

export default {
    name: 'productCustomerInfo',
    components: {
        InfoModal,
    },
    data() {
        return {
            show: false,
        };
    },
};
</script>

<style scoped lang="stylus">
@import '~vuetify/src/stylus/settings/_variables.styl';

.info-link {
  font-weight: bold;
  color: white;
}

.info-link:hover {
  color: var(--v-primary-base);
}

</style>
